
export const PAGE_ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  CLASSES: "/ourclasses",
  PROGRAMS: "/our-programs",
  PRICING: "/pricing",
  TERMS: "/terms-conditions",
  PRIVACY: "/privacy-policy",

  BLOG_BARRE: "/blog/what-is-barre",
  BLOG_PILATES: "/blog/what-is-pilates",
  BLOG_REBOUNDING: "/blog/what-is-rebounding",
  BLOG_BC_STRONG: "/blog/bc-strong",
  BLOG_BC_BABY: "/blog/bc-baby",
  BLOG_PJ_BARRE: "/blog/pyjama-barre",

  LOGIN: "/login",
  SIGN_UP: "/sign-up",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",

  CHECKOUT: "/checkout/:planCode",
  CHECKOUT_COMPLETE: "/checkout/complete",

  LIBRARY: "/library",
  WEEKLY_PLAN: "/library/weekly-plan",
  COLLECTION: "/library/:slug",
  ACCOUNT: "/account",
};

//Old Wix URLs that members may have bookmarked
export const LEGACY_REDIRECTS = {
  "/pricing-plans": "/pricing",
  "/subscription-barre": "/library/barre",
  "/subscription-pilates": "/library/pilates",
  "/subscription-rebounding": "/library/rebounding",
  "/subscription-bcbaby": "/library/bc-baby",
  "/subscription-pyjamabarre": "/library/pyjama-barre",
};

//interval: "Annual" / "Monthly", currency: "ZAR" / "USD" (both optional - the remembered choice is used otherwise)
export const getCheckoutRoute = (planCode, interval = null, currency = null) => {
  const params = new URLSearchParams();
  if (interval) {
    params.set("interval", interval);
  }
  if (currency) {
    params.set("currency", currency);
  }
  const query = params.toString();
  return PAGE_ROUTES.CHECKOUT.replace(":planCode", planCode) + (query ? `?${query}` : "");
};

export const getCollectionRoute = (slug) => (
  PAGE_ROUTES.COLLECTION.replace(":slug", slug)
);

//The admin (/admin) and the public site are separate apps with separate logins (index.js)
// Libraries members don't see yet (not in the Library menu or on My library) - they stay in the admin as normal.
// Take a slug out to show it again (e.g. "bc-strong" once its classes are uploaded).
export const HIDDEN_LIBRARIES = ["bc-strong"];

// Phone numbers: digits, an optional leading + and spaces, brackets or dashes between (the same check as the API's).
// Escaped for the browser's `pattern` attribute, which is strict about brackets & dashes in [ ].
export const PHONE_PATTERN = String.raw`\+?[0-9][0-9 \(\)\-]{7,24}[0-9]`;

export const IS_ADMIN_APP = window.location.pathname.startsWith("/admin");

//Login endpoints: admins use EcommerceCore's admin login (/Account), members BC nation's member login (/Member)
export const AUTH_API = IS_ADMIN_APP ? "/Account" : "/Member";

export const ADMIN_PAGE_ROUTES = {
  HOME: "/admin",
  REPORTS: "/admin/reports",
  MEMBERS: "/admin/members",
  MEMBER: "/admin/members/:userID",
  SUBSCRIPTIONS: "/admin/subscriptions",
  PAYMENTS: "/admin/payments",
  CLASSES: "/admin/classes",
  PLANS: "/admin/plans",
  COMMENTS: "/admin/comments",
  WEEKLY_PLANS: "/admin/weekly-plans",
  NEWSLETTER: "/admin/newsletter",
  ACCOUNT: "/admin/account",
};

export const getAdminMemberRoute = (userID) => (
  ADMIN_PAGE_ROUTES.MEMBER.replace(":userID", userID)
);

export const CONTACT_DETAILS = {
  EMAIL: "hello@bcnationfitness.com",
  INSTAGRAM: "https://www.instagram.com/bc_nation_fitness/",
  FACEBOOK: "https://www.facebook.com/bcnationfitness",
  YOUTUBE: "https://www.youtube.com/@BCnationfitness",
  TIKTOK: "https://www.tiktok.com/@bc.nationfitness",
};

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  LOGIN: "ls_1",
  REGISTER: "ls_2",
  FORGOT: "ls_3",
  RESET: "ls_4",
  PLANS: "ls_5",
  NEWSLETTER: "ls_6",
  CHECKOUT: "ls_7",
  LIBRARY: "ls_8",
  COLLECTION: "ls_9",
  MEMBERSHIP: "ls_10",
  CHANGE_PLAN: "ls_11",
  CANCEL: "ls_12",
  PROFILE: "ls_13",
  PASSWORD: "ls_14",
};

export const LS_ITEM_ADMIN = {
  SUMMARY_LOAD: "lsa_1",
  REPORTS_LOAD: "lsa_2",
  MEMBERS_LOAD: "lsa_3",
  MEMBER_LOAD: "lsa_4",
  MEMBER_ACTION: "lsa_5",
  SUBSCRIPTIONS_LOAD: "lsa_6",
  PAYMENTS_LOAD: "lsa_7",
  CLASSES_LOAD: "lsa_8",
  CLASS_SAVE: "lsa_9",
  PLANS_LOAD: "lsa_10",
  PLAN_SAVE: "lsa_11",
  NEWSLETTER_LOAD: "lsa_12",
  EXPORT: "lsa_13",
  PASSWORD_SAVE: "lsa_14",
  COMMENTS_LOAD: "lsa_15",
  COMMENT_SAVE: "lsa_16",
  WEEKLY_PLANS_LOAD: "lsa_17",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  ERROR: 1,
  SUCCESS: 2,
};

export const SUB_STATUS = {
  PENDING: "Pending",
  TRIALING: "Trialing",
  ACTIVE: "Active",
  CANCELLED: "Cancelled",
  ENDED: "Ended",
};

export const INTENSITIES = ["Low", "Medium", "High"];

export const CURRENCY = {
  ZAR: "ZAR",
  USD: "USD",
};

export const INTERVAL = {
  MONTHLY: "Monthly",
  ANNUAL: "Annual",
};

//Every focus tag a class can have (each library chooses which ones it shows as filters)
export const FOCUS_TAGS = ["Full Body", "Upper Body", "Lower Body", "Core", "Cardio", "Sculpt & Tone", "Stretching", "Bounce & Barre", "Strength", "No Equipment"];
export const INSTRUCTORS = ["Becca", "Cara", "Becca & Cara"];

//Duration filter chips on the library pages
export const DURATION_BUCKETS = [
  { id: "short", label: "Under 25 min", test: (m) => m !== null && m < 25 },
  { id: "30", label: "25 - 35 min", test: (m) => m !== null && m >= 25 && m <= 35 },
  { id: "45", label: "40 - 45 min", test: (m) => m !== null && m > 35 && m <= 45 },
  { id: "long", label: "50 min +", test: (m) => m !== null && m > 45 },
];
